import { css } from '@emotion/css'

export const formContainer = css`
  width: 100%;
`
export const titleContainer = css`
  margin-bottom: .5em;
  color: #464646;
`

export const secondaryTitle = css`
  font-weight: 400;
  font-size: 1em;
  color: #a2a2a2;
`

export const buttonContainer = css`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1em;

  button {
    align-items: center;
    display: flex;
    gap: 8px;
  }
`
